import React, { useState, useEffect, useRef } from "react";
import "./ModalEdicion.css";
import { getMedicoAuth,getCatalogoPais, getCatalogoEntidades, getCatalogoMunicipios, getCatalogoLocalidades,  getCatalogoAfiliacion } from "../../../../services/usuarios";
import { updatePaciente } from "../../../../services/pacientes";
import {validarNombreLongitud,validarNombreEspacios,validarNombreCaracteres,quitarAcentos,
   normalizarCURP,validarLongitudCURP,validarDigitoVerificador,
   validarCURPContraDatos,validarFechaCURP,calcularEdadDesdeCURP,validarFechaNacimientoMinima,calcularEdadDesdeFechaNacimiento,
   validarEdadPaciente,esCurpExtranjero,entidadNacimientoUsaCurpGenerica,
   paisNacimientoUsaCurpGenerica,
   validarCurpPacienteVsPrestador, prepararPacienteConFechaNacimientoEstimada,
  prepararPacienteSinFechaNacimientoEstimada, validarSigloCURPContraFechaNacimiento,
  aplicarAnioNacimientoEstimadoPaciente, validarFechaNacimientoNoFutura,
  pacienteTieneFechaNacimientoEstimadaActiva, obtenerAnioDesdeFechaNacimientoEstimada,
  obtenerMesDesdeFechaNacimientoEstimada,
  esFechaNacimientoEstimadaMenorDeUnAnio,
  aplicarMesNacimientoEstimadoPaciente,
  prepararPacienteMenorDeUnAnio,
  prepararPacienteNoMenorDeUnAnio,
  validarMenorDeUnAnio,
  validarMayorOIgualAUnAnio} from "../../../../utils/validaciones/identidad";
import {msgNombreLongitud,msgNombreEspacios,msgNombreCaracteres,
   msgApellidoPaternoLongitud,msgApellidoPaternoEspacios,msgApellidoPaternoCaracteres,
   msgApellidoMaternoLongitud,msgApellidoMaternoEspacios,msgApellidoMaternoCaracteres,
   msgLongitudCURP,msgDigitoVerificador,msgFechaCURP,msgEdadPaciente,msgFechaNacimientoMinima,msgFechaNacimientoRequerida,
   msgFechaNacimientoNoFutura,msgApellidoMaternoRequeridoCURP, msgEntidadNacimientoRequeridaCURP,
   msgPaisNacimientoRequeridoCURP,msgSigloCURPFechaNacimiento,
   msgCurpPos1,msgCurpPos2,msgCurpPos3,msgCurpPos4,
   msgCurpPos5,msgCurpPos6,msgCurpPos7,msgCurpPos8,msgCurpPos9,msgCurpPos10,
   msgCurpPos11,msgCurpPos12,msgCurpPos13,msgCurpPos14,msgCurpPos15,msgCurpPos16,
   msgCurpPacientePrestador, msgEdadEstimadaNoMenorDeUnAnio,
  msgEdadEstimadaNoMayorOIgualAUnAnio,
  msgMesNacimientoRequerido} from "../../../../utils/validaciones/mensajes";
import { valoresGeoPorPais, valoresGeoPorEntidad, valoresGeoPorMunicipio, esEntidadEspecial, esMunicipioEspecial } from "../../../../utils/validaciones/catalogos";
import ConfirmarPalabraInconvenienteCURP from "../../../../utils/validaciones/ConfirmarPalabraInconvenienteCURP";

const ModalEditarPaciente = ({ paciente, nom024 = false, tieneAtencionDesdeActivacionNom = false, onClose, onSave }) => {
  const [medicoActivo, setMedicoActivo] = useState(null);
  const [confirmarPalabraInconveniente, setConfirmarPalabraInconveniente] = useState(false);
  const [curpPalabraInconvenienteConfirmada, setCurpPalabraInconvenienteConfirmada] = useState(false);
  const curpPalabraInconvenienteConfirmadaRef = useRef(false);
  const formEditarPacienteRef = useRef(null);
  const cambioPaisNacimientoUsuarioRef = useRef(false);

  useEffect(() => {
    const fetchMedico = async () => {
      const medicos = await getMedicoAuth();
      if (medicos.length > 0) {
        setMedicoActivo(medicos[0]);
      }
    };
    fetchMedico();
  }, []);

  // Inicializamos el estado y, si paciente ya tiene notasModificacion, las preservamos
  const sexoReverseMap = { "M": "Hombre", "F": "Mujer", "O": "Intersexual" };
  const bloqueado = nom024 && tieneAtencionDesdeActivacionNom;

 const normalizarGeoPaciente = (p = {}) => ({
  ...p,
  paisResidencia: p?.paisResidencia ? String(p.paisResidencia) : null,
  entidadResidencia: p?.entidadResidencia ? String(p.entidadResidencia).padStart(2, "0") : null,
  municipio: p?.municipio ? String(p.municipio).padStart(3, "0") : null,
  localidad: p?.localidad ? String(p.localidad).padStart(4, "0") : null,
  paisNacPaciente: p?.paisNacPaciente ? String(p.paisNacPaciente) : null,
  entidadNacimiento: p?.entidadNacimiento ? String(p.entidadNacimiento).padStart(2, "0") : null,
  anio_nacimiento_estimado: p?.fecha_nacimiento_estimada
     ? obtenerAnioDesdeFechaNacimientoEstimada(p?.fecha_nacimiento)
     : "",
  menor_de_un_anio: p?.fecha_nacimiento_estimada
     ? esFechaNacimientoEstimadaMenorDeUnAnio(p?.fecha_nacimiento)
     : false,
  mes_nacimiento_estimado: p?.fecha_nacimiento_estimada
     ? obtenerMesDesdeFechaNacimientoEstimada(p?.fecha_nacimiento)
     : "",
});

  const parseAfiliacionPaciente = (valor) => {
  if (!valor) return [];
  if (Array.isArray(valor)) return valor.map(String).filter(Boolean);

  return String(valor)
    .split("&")
    .map((v) => v.trim())
    .filter(Boolean);
};

const pacienteNormalizadoInicial = normalizarGeoPaciente(paciente);

const [datosPaciente, setDatosPaciente] = useState({
  ...pacienteNormalizadoInicial,
  sexo: sexoReverseMap[pacienteNormalizadoInicial?.sexo] || pacienteNormalizadoInicial?.sexo || "",
  afiliacion: parseAfiliacionPaciente(pacienteNormalizadoInicial?.derechohabiencia),
  direccion: pacienteNormalizadoInicial.direccion || { calle: "", colonia: "", ciudad: "", estado: "", codigo_postal: "" },
  notasModificacion: pacienteNormalizadoInicial.notasModificacion || {}
});

  // Si el prop "paciente" cambia, actualizamos el estado pero fusionando las notas previas
 useEffect(() => {
  const pacienteNormalizado = normalizarGeoPaciente(paciente);

  setDatosPaciente((prev) => ({
    ...pacienteNormalizado,
    sexo: sexoReverseMap[pacienteNormalizado?.sexo] || pacienteNormalizado?.sexo || "",
    afiliacion: parseAfiliacionPaciente(pacienteNormalizado?.derechohabiencia),
    direccion: pacienteNormalizado.direccion || { calle: "", colonia: "", ciudad: "", estado: "", codigo_postal: "" },
    notasModificacion: prev?.notasModificacion || pacienteNormalizado.notasModificacion || {}
  }));
}, [paciente]);

  const [listaPaises, setListaPaises] = useState([]);
  const [listaEntidades, setListaEntidades] = useState([]);
  const [curpPrestador, setCurpPrestador] = useState(null);
  const [listaMunicipios, setListaMunicipios] = useState([]);
  const [listaLocalidades, setListaLocalidades] = useState([]);
  const [listaAfiliacion, setListaAfiliacion] = useState([]);
  const [afiliacionAbierta, setAfiliacionAbierta] = useState(false);

  useEffect(() => {
    const cargarCatalogos = async () => {
      const paises = await getCatalogoPais();
      const ordenados = paises.sort((a, b) =>
        (a.DESCRIPCION || "").trim().localeCompare((b.DESCRIPCION || "").trim(), 'es')
      );
      setListaPaises(ordenados);

      const entidades = await getCatalogoEntidades();
      setListaEntidades(entidades);

      const afiliaciones = await getCatalogoAfiliacion();
      setListaAfiliacion(afiliaciones);

      const medico = await getMedicoAuth();
      if (medico && medico.curpPrestador) {
        setCurpPrestador(medico.curpPrestador);
      }
    };
    cargarCatalogos();
  }, []);

  useEffect(() => {
  const precargarResidenciaPaciente = async () => {
    if (String(datosPaciente.paisResidencia) !== "142") {
      setListaMunicipios([]);
      setListaLocalidades([]);
      return;
    }

    if (!datosPaciente.entidadResidencia || esEntidadEspecial(datosPaciente.entidadResidencia)) {
      setListaMunicipios([]);
      setListaLocalidades([]);
      return;
    }

    const entidad = String(datosPaciente.entidadResidencia).padStart(2, "0");

    const municipios = await getCatalogoMunicipios(entidad);
    setListaMunicipios(
      municipios.sort((a, b) =>
        (a.MUNICIPIO || "").trim().localeCompare((b.MUNICIPIO || "").trim(), "es")
      )
    );

    if (!datosPaciente.municipio || esMunicipioEspecial(datosPaciente.municipio)) {
      setListaLocalidades([]);
      return;
    }

    const municipio = String(datosPaciente.municipio).padStart(3, "0");

    const localidades = await getCatalogoLocalidades(entidad, municipio);
    setListaLocalidades(
      localidades.sort((a, b) =>
        (a.LOCALIDAD || "").trim().localeCompare((b.LOCALIDAD || "").trim(), "es")
      )
    );
  };

  precargarResidenciaPaciente();
}, [
  datosPaciente.paisResidencia,
  datosPaciente.entidadResidencia,
  datosPaciente.municipio
]);

 useEffect(() => {
  if (!cambioPaisNacimientoUsuarioRef.current) return;
  cambioPaisNacimientoUsuarioRef.current = false;
  if (!datosPaciente.paisNacPaciente) {
    setDatosPaciente((prev) => ({
      ...prev,
      entidadNacimiento: null,
      curp: esCurpExtranjero(prev.curp)
        ? ""
        : prev.curp,
    }));
    return;
  }

  if (Number(datosPaciente.paisNacPaciente) === 142) {
    setDatosPaciente((prev) => ({
      ...prev,
      entidadNacimiento: null,
      curp: esCurpExtranjero(prev.curp)
        ? ""
        : prev.curp,
    }));
    return;
  }

  const geo = valoresGeoPorPais(datosPaciente.paisNacPaciente);

  const usaCurpGenerica = paisNacimientoUsaCurpGenerica(
    datosPaciente.paisNacPaciente
  );

  setDatosPaciente((prev) => ({
    ...prev,
    entidadNacimiento: geo.entidad,
    curp: usaCurpGenerica
      ? "XXXX999999XXXXXX99"
      : esCurpExtranjero(prev.curp)
        ? ""
        : prev.curp,
  }));
}, [datosPaciente.paisNacPaciente]);

  useEffect(() => {
    if (datosPaciente.migrante === 1 || datosPaciente.migrante === 3) {
      setDatosPaciente(prev => ({
        ...prev,
        paisProcedencia: 142
      }));
    }
    if (datosPaciente.migrante === 0 || datosPaciente.migrante === null) {
      setDatosPaciente(prev => ({
        ...prev,
        paisProcedencia: null
      }));
    }
  }, [datosPaciente.migrante]);

  const calcularSexoCURP = (curp, sexoCURPManual = null) => {
  const curpNormalizada = normalizarCURP(curp || "");

  if (
    !curpNormalizada ||
    curpNormalizada.length !== 18 ||
    esCurpExtranjero(curpNormalizada)
  ) {
    return sexoCURPManual ?? null;
  }

  const caracterSexo = curpNormalizada.charAt(10);

  if (caracterSexo === "H") return 1;
  if (caracterSexo === "M") return 2;
  if (caracterSexo === "X") return 3;

  return sexoCURPManual ?? null;
};

 const handleFechaEstimadaChange = (checked) => {
   if (!nom024) return;

   setDatosPaciente((prev) =>
     checked
       ? prepararPacienteConFechaNacimientoEstimada(prev)
       : prepararPacienteSinFechaNacimientoEstimada(prev)
   );
 };

 const handleAnioNacimientoEstimadoChange = (e) => {
   const value = e.target.value;

   if (!value) {
   setDatosPaciente((prev) => prepararPacienteSinFechaNacimientoEstimada(prev));
   return;
 }

   setDatosPaciente((prev) =>
     aplicarAnioNacimientoEstimadoPaciente(prev, value)
   );
 };

 const handleMenorDeUnAnioChange = (checked) => {
   if (!nom024) return;

   setDatosPaciente((prev) =>
     checked
       ? prepararPacienteMenorDeUnAnio(prev)
       : prepararPacienteNoMenorDeUnAnio(prev)
   );
 };

 const handleMesNacimientoEstimadoChange = (e) => {
   const value = e.target.value;
   setDatosPaciente((prev) =>
     aplicarMesNacimientoEstimadoPaciente(prev, value)
   );
 };


  const handleChange = (e) => {
    const { name, value } = e.target;
  

    setDatosPaciente((prev) => {
      const cambios = { ...prev };

     if (name === "curp") {
  curpPalabraInconvenienteConfirmadaRef.current = false;
  setCurpPalabraInconvenienteConfirmada(false);
  const curpNorm = normalizarCURP(value);
  const esGenerica = esCurpExtranjero(curpNorm);

  
    cambios.curp = curpNorm;
    cambios.sexoCURP = esGenerica
      ? cambios.sexoCURP ?? null
      : calcularSexoCURP(curpNorm, cambios.sexoCURP);
  

  return cambios;
}

      // Detectar si es un campo de dirección (ahora con el nombre completo)
      if (name.startsWith('direccion.')) {
        const campoDireccion = name.split('.')[1];
    
        
        cambios.direccion = {
          ...prev.direccion,
          [campoDireccion]: value
        };
      } else {
        cambios[name] = value;
      }

      // Campos que requieren trazabilidad
      const camposConNotaCambio = [
        "nombre",
        "apellido_paterno",
        "apellido_materno",
        "fecha_nacimiento",
        "sexo",
        "curp",
        "nacionalidad",
        "telefono",
        "correo",
        "estado_civil",
        "motivo_consulta"
      ];

      if (camposConNotaCambio.includes(name) && medicoActivo) {
        const nombreMedico = `${medicoActivo.nombre} ${medicoActivo.apellido_paterno}`;
        const fechaModificacion = new Date().toLocaleString();

        // Si ya existe una nota, se conserva el "primerValor", de lo contrario se toma el valor original
        const valorInicial =
          (prev.notasModificacion && prev.notasModificacion[name] && prev.notasModificacion[name].primerValor) ||
          (paciente[name] || "");

        // Creamos el objeto de notas fusionando las previas y actualizando solo el campo que cambió
        const nuevasNotas = {
          ...prev.notasModificacion,
          [name]: {
            primerValor: valorInicial,
            ultimaModificacion: {
              valor: value,
              fecha: fechaModificacion,
              medico: nombreMedico
            }
          }
        };

        cambios.notasModificacion = nuevasNotas;
      }

      return cambios;
    });
  };

  const handleAfiliacionChange = (catalogKey) => {
  const valor = String(catalogKey);
  const valoresExclusivos = ["0", "1", "99"];

  setDatosPaciente((prev) => {
    const actuales = Array.isArray(prev.afiliacion)
      ? prev.afiliacion.map(String)
      : [];

    if (valoresExclusivos.includes(valor)) {
      return {
        ...prev,
        afiliacion: actuales.includes(valor) ? [] : [valor],
      };
    }

    let nuevos = actuales.filter((v) => !valoresExclusivos.includes(v));

    if (nuevos.includes(valor)) {
      nuevos = nuevos.filter((v) => v !== valor);
    } else {
      if (nuevos.length >= 9) {
        alert("Solo puedes seleccionar hasta 9 afiliaciones.");
        return prev;
      }
      nuevos = [...nuevos, valor];
    }

    return {
      ...prev,
      afiliacion: nuevos,
    };
  });
};

const getResumenAfiliacion = () => {
  const afiliacionesSeleccionadas = Array.isArray(datosPaciente.afiliacion)
    ? datosPaciente.afiliacion
    : [];

  return afiliacionesSeleccionadas
    .map((clave) => {
      const item = listaAfiliacion.find(
        (a) => String(a.CATALOG_KEY) === String(clave)
      );
      return item?.["DESCRIPCIÓN CORTA"] || item?.["DESCRIPCIÓN LARGA"] || clave;
    })
    .join(", ");
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    

    if (!validarFechaNacimientoMinima(datosPaciente.fecha_nacimiento)) {
     msgFechaNacimientoMinima();
     return;
   }

 if (!validarFechaNacimientoNoFutura(datosPaciente.fecha_nacimiento)) {
      msgFechaNacimientoNoFutura();
      return;
    }

    // Candados de coherencia para fecha estimada (NOM-024)
    if (nom024 && datosPaciente.fecha_nacimiento_estimada) {
      if (datosPaciente.menor_de_un_anio && !datosPaciente.mes_nacimiento_estimado) {
        msgMesNacimientoRequerido();
        return;
      }

      if (datosPaciente.fecha_nacimiento) {
        if (datosPaciente.menor_de_un_anio) {
          if (!validarMenorDeUnAnio(datosPaciente.fecha_nacimiento)) {
            msgEdadEstimadaNoMenorDeUnAnio();
            return;
          }
        } else {
          if (!validarMayorOIgualAUnAnio(datosPaciente.fecha_nacimiento)) {
            msgEdadEstimadaNoMayorOIgualAUnAnio();
            return;
          }
        }
      }
    }

    const curp = normalizarCURP(datosPaciente.curp || "");

    if (curp) {
   
    if (!validarLongitudCURP(curp)) {
      msgLongitudCURP();
      return;
    }

    if (!validarDigitoVerificador(curp)) {
      msgDigitoVerificador();
      return;
    }

    if (!validarCurpPacienteVsPrestador(curp, curpPrestador)) {
      msgCurpPacientePrestador();
      return;
    }

    // Si es genérica, saltar validaciones de posiciones
    if (!esCurpExtranjero(curp)) {

      const resultadoCURP = validarCURPContraDatos(
    curp,
    datosPaciente.nombre || "",
    datosPaciente.apellido_paterno || "",
    datosPaciente.apellido_materno || "",
    datosPaciente.fecha_nacimiento || "",
    datosPaciente.sexoCURP,
    datosPaciente.entidadNacimiento || "",
    listaEntidades,
    datosPaciente.paisNacPaciente
  );

      if (!resultadoCURP.valida) {
        const msgsPorPosicion = {  
          1: msgCurpPos1, 2: msgCurpPos2, 3: msgCurpPos3, 4: msgCurpPos4,
          5: msgCurpPos5, 6: msgCurpPos6, 7: msgCurpPos7, 8: msgCurpPos8,
          9: msgCurpPos9, 10: msgCurpPos10, 11: msgCurpPos11, 12: msgCurpPos12,
          13: msgCurpPos13, 14: msgCurpPos14, 15: msgCurpPos15, 16: msgCurpPos16
        };
       resultadoCURP.errores.forEach(err => {
        if (err.posicion === 0) {
          if (err.motivo === "fecha_requerida") msgFechaNacimientoRequerida();
          if (err.motivo === "apellido_materno_requerido") msgApellidoMaternoRequeridoCURP();
           if (err.motivo === "pais_nacimiento_requerido") msgPaisNacimientoRequeridoCURP();
          if (err.motivo === "entidad_nacimiento_requerida") msgEntidadNacimientoRequeridaCURP();
          return;
        }

        const msgFn = msgsPorPosicion[err.posicion];
        if (msgFn) msgFn();
      });
        return;
      }

      if (!validarFechaCURP(curp)) {
        msgFechaCURP();
        return;
      }

      if (!validarSigloCURPContraFechaNacimiento(curp, datosPaciente.fecha_nacimiento)) {
        msgSigloCURPFechaNacimiento();
        return;
      }

      const edad = calcularEdadDesdeCURP(curp);

      if (!validarEdadPaciente(edad)) {
        msgEdadPaciente();
      }

      if (
        resultadoCURP.requiereConfirmacionPalabraInconveniente &&
        !curpPalabraInconvenienteConfirmadaRef.current
      ) {
        setConfirmarPalabraInconveniente(true);
        return;
      }

    } // fin de !esCurpExtranjero
    } // fin de if (curp)
    // Crear una copia de los datos para manipularlos antes de enviar
    const datosPacienteParaEnviar = { ...datosPaciente };
    datosPacienteParaEnviar.derechohabiencia = Array.isArray(datosPaciente.afiliacion) && datosPaciente.afiliacion.length
      ? datosPaciente.afiliacion.join("&")
      : null;

    delete datosPacienteParaEnviar.afiliacion;
    datosPacienteParaEnviar.sexoCURP = calcularSexoCURP(
      datosPacienteParaEnviar.curp,
      datosPacienteParaEnviar.sexoCURP
    );
    const sexoMap = { "Hombre": "M", "Mujer": "F", "Intersexual": "O" };
    datosPacienteParaEnviar.sexo = sexoMap[datosPacienteParaEnviar.sexo] || datosPacienteParaEnviar.sexo;

     // Convertir strings vacíos a null para que el backend acepte el clear
    datosPacienteParaEnviar.fecha_nacimiento = datosPacienteParaEnviar.fecha_nacimiento || null;

    
    // Eliminar notasModificacion ya que no está en el modelo/serializer
    // Este campo es solo para el frontend
    delete datosPacienteParaEnviar.notasModificacion;
    
    // Asegurar que la estructura de dirección sea correcta
    if (datosPacienteParaEnviar.direccion) {
      // Si algún campo de dirección está vacío, establecerlo como cadena vacía 
      // en lugar de null/undefined para evitar problemas de validación
      const direccionLimpia = {};
      const camposDireccion = ['calle', 'colonia', 'ciudad', 'estado', 'codigo_postal'];
      
      camposDireccion.forEach(campo => {
        direccionLimpia[campo] = datosPacienteParaEnviar.direccion[campo] || '';
      });
      
      datosPacienteParaEnviar.direccion = direccionLimpia;
    }
    
   

    try {
      const response = await updatePaciente(datosPacienteParaEnviar.id, datosPacienteParaEnviar);
      if (response) {
       
        onSave(response);
        onClose();
      } else {
        console.error("❌ Error al actualizar paciente en el backend.");
      }
    } catch (error) {
      console.error("❌ Error en handleSubmit:", error);
    }
  };

  // Función para renderizar la nota de modificación de cada campo
  const renderNota = (campo) => {
    const nota = datosPaciente.notasModificacion?.[campo];
    if (!nota) return null;
    return (
      <p className="nota">
        Valor inicial: '{nota.primerValor}' | Última modificación: '{nota.ultimaModificacion.valor}' por {nota.ultimaModificacion.medico} el {nota.ultimaModificacion.fecha}
      </p>
    );
  };

  // Cascada residencia
 const handlePaisResidencia = (valor) => {
  const valorNormalizado = valor ? String(valor) : null;
  const geo = valoresGeoPorPais(valorNormalizado);

  setDatosPaciente((prev) => ({
    ...prev,
    paisResidencia: valorNormalizado,
    entidadResidencia: geo.entidad,
    municipio: geo.municipio,
    localidad: geo.localidad,
  }));

  setListaMunicipios([]);
  setListaLocalidades([]);
};

  const handleEntidadResidencia = async (valor) => {
  const valorNormalizado = valor ? String(valor).padStart(2, "0") : null;
  const geo = valoresGeoPorEntidad(valorNormalizado);

  setDatosPaciente((prev) => ({
    ...prev,
    entidadResidencia: valorNormalizado,
    municipio: geo.municipio,
    localidad: geo.localidad,
  }));
    setListaLocalidades([]);
    if (valorNormalizado && !esEntidadEspecial(valorNormalizado)) {
  const municipios = await getCatalogoMunicipios(valorNormalizado);
      setListaMunicipios(municipios.sort((a, b) => (a.MUNICIPIO || "").trim().localeCompare((b.MUNICIPIO || "").trim(), 'es')));
    } else {
      setListaMunicipios([]);
    }
  };

 const handleMunicipio = async (valor) => {
  const valorNormalizado = valor ? String(valor).padStart(3, "0") : null;
  const geo = valoresGeoPorMunicipio(valorNormalizado);

  setDatosPaciente((prev) => ({
    ...prev,
    municipio: valorNormalizado,
    localidad: geo.localidad,
  }));
    setListaLocalidades([]);
    if (valorNormalizado && !esMunicipioEspecial(valorNormalizado) && datosPaciente.entidadResidencia) {
  const localidades = await getCatalogoLocalidades(datosPaciente.entidadResidencia, valorNormalizado);
      setListaLocalidades(localidades.sort((a, b) => (a.LOCALIDAD || "").trim().localeCompare((b.LOCALIDAD || "").trim(), 'es')));
    }
  };

   

  const handleBlurCURPPaciente = () => {
    const curp = normalizarCURP(datosPaciente.curp || "");
    if (!curp) return;

    if (!validarLongitudCURP(curp)) {
      msgLongitudCURP();
      return;
    }

    if (!validarCurpPacienteVsPrestador(curp, curpPrestador)) {
      msgCurpPacientePrestador();
      return;
    }

    if (esCurpExtranjero(curp)) return;

    if (!validarFechaCURP(curp)) {
      msgFechaCURP();
      return;
    }

    if (!validarSigloCURPContraFechaNacimiento(curp, datosPaciente.fecha_nacimiento)) {
      msgSigloCURPFechaNacimiento();
      return;
    }

    if (!validarDigitoVerificador(curp)) {
      msgDigitoVerificador();
      return;
    }  

    const edad = calcularEdadDesdeCURP(curp);
    if (!validarEdadPaciente(edad)) {
      msgEdadPaciente();
      return;
    }

    const resultadoCURP = validarCURPContraDatos(
      curp,
      datosPaciente.nombre || "",
      datosPaciente.apellido_paterno || "",
      datosPaciente.apellido_materno || "",
      datosPaciente.fecha_nacimiento || "",
      datosPaciente.sexoCURP,
      datosPaciente.entidadNacimiento || "",
      listaEntidades,
      datosPaciente.paisNacPaciente
    );

    if (!resultadoCURP.valida) {
      const msgsPorPosicion = {
        1: msgCurpPos1, 2: msgCurpPos2, 3: msgCurpPos3, 4: msgCurpPos4,
        5: msgCurpPos5, 6: msgCurpPos6, 7: msgCurpPos7, 8: msgCurpPos8,
        9: msgCurpPos9, 10: msgCurpPos10, 11: msgCurpPos11, 12: msgCurpPos12,
        13: msgCurpPos13, 14: msgCurpPos14, 15: msgCurpPos15, 16: msgCurpPos16
      };
      resultadoCURP.errores.forEach(err => {
        const msgFn = msgsPorPosicion[err.posicion];
        if (msgFn) msgFn();
      });
    }
  };


  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Editar Información del Paciente</h3>
        <form ref={formEditarPacienteRef} onSubmit={handleSubmit}>
          {/* Ejemplo para "nombre" */}
          <h4>Datos Generales</h4>
           <p>Los campos marcados con * son obligatorios.</p>
          <label>Nombre*:</label>
          <input
            type="text"
            name="nombre"
             disabled={bloqueado}
            value={datosPaciente.nombre || ""}
            onChange={handleChange}
            onBlur={(e) => {
              const v = quitarAcentos(e.target.value.trim());
              setDatosPaciente(prev => ({ ...prev, nombre: v }));
              if (!validarNombreLongitud(v)) {
                msgNombreLongitud();
                setDatosPaciente(prev => ({ ...prev, nombre: "" }))
              } else if (!validarNombreEspacios(v)) {
                msgNombreEspacios();
                setDatosPaciente(prev => ({ ...prev, nombre: "" }));
              } else if (!validarNombreCaracteres(v)) {
                msgNombreCaracteres();
                setDatosPaciente(prev => ({ ...prev, nombre: "" }));
              }
            }}
          />
          {renderNota("nombre")}

          {/* Apellido Paterno */}
          <label>Apellido Paterno*:</label>
          <input
            type="text"
            name="apellido_paterno"
            disabled={bloqueado}
            value={datosPaciente.apellido_paterno || ""}
            onChange={handleChange}
             onBlur={(e) => {
              const v = quitarAcentos(e.target.value.trim());
              setDatosPaciente(prev => ({ ...prev, apellido_paterno: v }));
              if (!validarNombreLongitud(v)) {
                msgApellidoPaternoLongitud();
                setDatosPaciente(prev => ({ ...prev, apellido_paterno: "" }));
              } else if (!validarNombreEspacios(v)) {
                msgApellidoPaternoEspacios();
                setDatosPaciente(prev => ({ ...prev, apellido_paterno: "" }));
              } else if (!validarNombreCaracteres(v)) {
                msgApellidoPaternoCaracteres();
                setDatosPaciente(prev => ({ ...prev, apellido_paterno: "" }));
              }
            }}
          />
          {renderNota("apellido_paterno")}

          {/* Apellido Materno */}
          <label>Apellido Materno*:</label>
          <input
            type="text"
            name="apellido_materno"
            disabled={bloqueado}
            value={datosPaciente.apellido_materno || ""}
            onChange={handleChange}
            onBlur={(e) => {
              const v = quitarAcentos(e.target.value.trim());
              setDatosPaciente(prev => ({ ...prev, apellido_materno: v }));
              if (!validarNombreLongitud(v)) {
                msgApellidoMaternoLongitud();
                setDatosPaciente(prev => ({ ...prev, apellido_materno: "" }));
              } else if (!validarNombreEspacios(v)) {
                msgApellidoMaternoEspacios();
                setDatosPaciente(prev => ({ ...prev, apellido_materno: "" }));
              } else if (!validarNombreCaracteres(v)) {
                msgApellidoMaternoCaracteres();
                setDatosPaciente(prev => ({ ...prev, apellido_materno: "" }));
              }
            }}
          />
          {renderNota("apellido_materno")}

          {/* Fecha de Nacimiento */}
          {nom024 && datosPaciente.fecha_nacimiento_estimada ? (
              <>
                {/* Input de mes — solo cuando es menor de 1 año */}
                {datosPaciente.menor_de_un_anio && (
                  <>
                    <label>Mes aproximado de nacimiento:</label>
                    <select
                      name="mes_nacimiento_estimado"
                      value={datosPaciente.mes_nacimiento_estimado || ""}
                      disabled={bloqueado}
                      onChange={handleMesNacimientoEstimadoChange}
                      onBlur={() => {
                        if (!datosPaciente.anio_nacimiento_estimado || !datosPaciente.mes_nacimiento_estimado) return;
                        if (!datosPaciente.fecha_nacimiento) return;

                        if (!validarFechaNacimientoNoFutura(datosPaciente.fecha_nacimiento)) {
                          msgFechaNacimientoNoFutura();
                          setDatosPaciente(prev => ({
                            ...prev,
                            fecha_nacimiento: "",
                            mes_nacimiento_estimado: "",
                          }));
                          return;
                        }

                        if (datosPaciente.menor_de_un_anio) {
                          if (!validarMenorDeUnAnio(datosPaciente.fecha_nacimiento)) {
                            msgEdadEstimadaNoMenorDeUnAnio();
                            setDatosPaciente(prev => ({
                              ...prev,
                              fecha_nacimiento: "",
                              mes_nacimiento_estimado: "",
                            }));
                            return;
                          }
                        }
                      }}
                    >
                      <option value="">Mes aproximado de nacimiento*</option>
                      <option value="01">Enero</option>
                      <option value="02">Febrero</option>
                      <option value="03">Marzo</option>
                      <option value="04">Abril</option>
                      <option value="05">Mayo</option>
                      <option value="06">Junio</option>
                      <option value="07">Julio</option>
                      <option value="08">Agosto</option>
                      <option value="09">Septiembre</option>
                      <option value="10">Octubre</option>
                      <option value="11">Noviembre</option>
                      <option value="12">Diciembre</option>
                    </select>
                  </>
                )}

                <label>Año aproximado de nacimiento:</label>
                <input
                  type="text"
                  name="anio_nacimiento_estimado"
                  placeholder="Año aproximado de nacimiento*"
                  value={datosPaciente.anio_nacimiento_estimado || ""}
                  maxLength={4}
                  disabled={bloqueado}
                  onChange={handleAnioNacimientoEstimadoChange}
                  onBlur={() => {
                    // Si está marcado menor de 1 año pero falta mes, avisar y salir.
                    if (datosPaciente.menor_de_un_anio && !datosPaciente.mes_nacimiento_estimado) {
                      msgMesNacimientoRequerido();
                      return;
                    }

                    if (!datosPaciente.fecha_nacimiento) return;

                    if (!validarFechaNacimientoMinima(datosPaciente.fecha_nacimiento)) {
                      msgFechaNacimientoMinima();
                      setDatosPaciente(prev => ({
                        ...prev,
                        fecha_nacimiento: "",
                        anio_nacimiento_estimado: "",
                        mes_nacimiento_estimado: "",
                      }));
                      return;
                    }

                    if (!validarFechaNacimientoNoFutura(datosPaciente.fecha_nacimiento)) {
                      msgFechaNacimientoNoFutura();
                      setDatosPaciente(prev => ({
                        ...prev,
                        fecha_nacimiento: "",
                        anio_nacimiento_estimado: "",
                        mes_nacimiento_estimado: "",
                      }));
                      return;
                    }

                    const edad = calcularEdadDesdeFechaNacimiento(datosPaciente.fecha_nacimiento);
                    if (!validarEdadPaciente(edad)) {
                      msgEdadPaciente();
                      setDatosPaciente(prev => ({
                        ...prev,
                        fecha_nacimiento: "",
                        anio_nacimiento_estimado: "",
                        mes_nacimiento_estimado: "",
                      }));
                      return;
                    }

                    // Candado de coherencia entre el flag "menor de 1 año" y la fecha resultante.
                    if (datosPaciente.menor_de_un_anio) {
                      if (!validarMenorDeUnAnio(datosPaciente.fecha_nacimiento)) {
                        msgEdadEstimadaNoMenorDeUnAnio();
                        setDatosPaciente(prev => ({
                          ...prev,
                          fecha_nacimiento: "",
                          anio_nacimiento_estimado: "",
                          mes_nacimiento_estimado: "",
                        }));
                        return;
                      }
                    } else {
                      if (!validarMayorOIgualAUnAnio(datosPaciente.fecha_nacimiento)) {
                        msgEdadEstimadaNoMayorOIgualAUnAnio();
                        setDatosPaciente(prev => ({
                          ...prev,
                          fecha_nacimiento: "",
                          anio_nacimiento_estimado: "",
                        }));
                        return;
                      }
                    }
                  }}
                />
                <p style={{ fontSize: "12px", color: "#6b7280", marginTop: "-6px" }}>
                  {datosPaciente.menor_de_un_anio
                    ? `Se registrará como 15/${datosPaciente.mes_nacimiento_estimado || "[mes]"}/${datosPaciente.anio_nacimiento_estimado || "[año]"} conforme a la guía.`
                    : `Se registrará como 30/06/${datosPaciente.anio_nacimiento_estimado || "[año]"} conforme a la guía.`}
                </p>
              </>
            ) : (
              <>
                <label>Fecha de Nacimiento*:</label>
                <input
                  type="date"
                  name="fecha_nacimiento"
                  disabled={bloqueado}
                  value={datosPaciente.fecha_nacimiento || ""}
                  onChange={handleChange}
                  onBlur={() => {
                    if (!validarFechaNacimientoMinima(datosPaciente.fecha_nacimiento)) {
                      msgFechaNacimientoMinima();
                      setDatosPaciente(prev => ({ ...prev, fecha_nacimiento: "" }));
                    }
                    if (!validarFechaNacimientoNoFutura(datosPaciente.fecha_nacimiento)) {
                      msgFechaNacimientoNoFutura();
                      setDatosPaciente(prev => ({ ...prev, fecha_nacimiento: "" }));
                      return;
                    }
                  }}
                />
              </>
            )}
            {renderNota("fecha_nacimiento")}

            {nom024 && (
              <label className="fecha-estimada-check">
                <input
                  type="checkbox"
                  checked={!!datosPaciente.fecha_nacimiento_estimada}
                  disabled={bloqueado}
                  onChange={(e) => handleFechaEstimadaChange(e.target.checked)}
                />
                <span>Se desconoce fecha de nacimiento</span>
              </label>
            )}

            {nom024 && datosPaciente.fecha_nacimiento_estimada && (
              <label className="fecha-estimada-check">
                <input
                  type="checkbox"
                  checked={!!datosPaciente.menor_de_un_anio}
                  disabled={bloqueado}
                  onChange={(e) => handleMenorDeUnAnioChange(e.target.checked)}
                />
                <span>Es menor de 1 año</span>
              </label>
            )}
          {/* Sexo */}
          <label>Sexo biológico*:</label>
          <select name="sexo" value={datosPaciente.sexo || ""} onChange={handleChange} disabled={bloqueado}>
            <option value="">Sexo *</option>
            <option value="Hombre">Hombre</option>
            <option value="Mujer">Mujer</option>
            <option value="Intersexual">Intersexual</option>
          </select>
          {renderNota("sexo")}


          {/* Teléfono */}
          <label>Teléfono:</label>
          <input
            type="tel"
            name="telefono"
            value={datosPaciente.telefono || ""}
            onChange={handleChange}
          />
          {renderNota("telefono")}

          {/* Correo Electrónico */}
          <label>Correo Electrónico:</label>
          <input
            type="email"
            name="correo"
            value={datosPaciente.correo || ""}
            onChange={handleChange}
          />
          {renderNota("correo")}
          {/* País de nacimiento */}
          <label>País de nacimiento*:</label>
          <select
            name="paisNacPaciente"
            value={datosPaciente.paisNacPaciente ?? ""}
            disabled={bloqueado}
            onChange={(e) => {
            cambioPaisNacimientoUsuarioRef.current = true;
              
              setDatosPaciente((prev) => ({
                ...prev,
                paisNacPaciente: e.target.value ? Number(e.target.value) : null,
                entidadNacimiento: null,
              }))
            }}
          >
            <option value="">Selecciona un país</option>
            {listaPaises.map((pais) => (
              <option
                key={pais.CATALOG_KEY}
                value={pais.CATALOG_KEY}
                
              >
                {pais.DESCRIPCION}
              </option>
            ))}
          </select>

          {Number(datosPaciente.paisNacPaciente) === 142 && (
            <>
              <label>Entidad de nacimiento*:</label>
              <select
                name="entidadNacimiento"
                disabled={bloqueado}
                value={datosPaciente.entidadNacimiento ?? ""}
               onChange={(e) => {
                  const entidad = e.target.value || null;
                  const usaCurpGenerica = entidadNacimientoUsaCurpGenerica(entidad);

                  setDatosPaciente((prev) => ({
                    ...prev,
                    entidadNacimiento: entidad,
                    curp: usaCurpGenerica
                      ? "XXXX999999XXXXXX99"
                      : esCurpExtranjero(prev.curp)
                        ? ""
                        : prev.curp,
                  }));
                }}
              >
                <option value="">Selecciona una entidad</option>
               {listaEntidades
                .filter((e) => String(e.CATALOG_KEY) !== "88")
                .map((e) => (
                  <option key={e.CATALOG_KEY} value={e.CATALOG_KEY}>
                    {e.ENTIDAD_FEDERATIVA}
                  </option>
                ))}
              </select>
            </>
          )}

          {/* CURP */}
          <label>CURP*:</label>
          <input
            type="text"
            name="curp"
           disabled={
              bloqueado ||
              pacienteTieneFechaNacimientoEstimadaActiva({ nom024 }, datosPaciente) ||
              entidadNacimientoUsaCurpGenerica(datosPaciente.entidadNacimiento) ||
              paisNacimientoUsaCurpGenerica(datosPaciente.paisNacPaciente)
            }
            maxLength={18}
            value={datosPaciente.curp || ""}
            onChange={handleChange}
            onBlur={handleBlurCURPPaciente}
          />
          {renderNota("curp")}
          
          {nom024 && (
            <>
              <label>Sexo registrado ante RENAPO*:</label>
              <select
                name="sexoCURP"
                value={datosPaciente.sexoCURP ?? ""}
                disabled={
            bloqueado ||
            (!!normalizarCURP(datosPaciente.curp || "") &&
              !esCurpExtranjero(normalizarCURP(datosPaciente.curp || "")))
          }
                onChange={(e) =>
                  setDatosPaciente(prev => ({
                    ...prev,
                    sexoCURP: e.target.value === "" ? null : Number(e.target.value)
                  }))
                }
              >
                <option value="">Seleccionar</option>
                <option value="1">HOMBRE</option>
                <option value="2">MUJER</option>
                <option value="3">NO BINARIO</option>
              </select>
            </>
          )}
          {/* Nacionalidad 
          <label>Nacionalidad:</label>
          <input
            type="text"
            name="nacionalidad"
            value={datosPaciente.nacionalidad || ""}
            onChange={handleChange}
          />
          {renderNota("nacionalidad")}*/}

          
          {/* Estado Civil */}
          <label>Estado Civil:</label>
          <select
            name="estado_civil"
            value={datosPaciente.estado_civil || ""}
            onChange={handleChange}
          >
            <option value="">Seleccionar</option>
            <option value="Soltero/a">Soltero/a</option>
            <option value="Casado/a">Casado/a</option>
            <option value="Divorciado/a">Divorciado/a</option>
            <option value="Viudo/a">Viudo/a</option>
            <option value="Unión Libre">Unión Libre</option>
            <option value="Otro">Otro</option>
          </select>
          {renderNota("estado_civil")}

          {/* Información sociodemográfica NOM-024 */}
          {nom024 && (
            <>
             <h4>Información sociodemográfica</h4>
            <div className="campo-afiliacion">
              <button
                type="button"
                className={`afiliacion-toggle ${afiliacionAbierta ? "abierto" : ""}`}
                onClick={() => setAfiliacionAbierta((prev) => !prev)}
              >
                <div>
                  <span className="afiliacion-label">Derechohabiencia*</span>
                  <span className={`afiliacion-resumen ${datosPaciente.afiliacion?.length ? "con-seleccion" : ""}`}>
                    {getResumenAfiliacion()}
                  </span>
                </div>
                <span className="afiliacion-flecha">
                  {afiliacionAbierta ? "▲" : "▼"}
                </span>
              </button>

              {afiliacionAbierta && (
                <div className="afiliacion-panel">
                  <p className="afiliacion-ayuda">
                    Selecciona la institución o instituciones del Sistema Nacional de Salud en las que el paciente se encuentra afiliado. Puedes elegir hasta 9 opciones; no especificado, ninguna y se ignora no se pueden combinar con otras.
                  </p>

                  <div className="afiliacion-opciones">
                    {listaAfiliacion.map((item) => {
                      const valor = String(item.CATALOG_KEY);
                      const seleccionadas = Array.isArray(datosPaciente.afiliacion)
                        ? datosPaciente.afiliacion.map(String)
                        : [];

                      const valoresExclusivos = ["0", "1", "99"];
                      const hayExclusivoSeleccionado = seleccionadas.some((v) =>
                        valoresExclusivos.includes(v)
                      );

                      const deshabilitado =
                        (
                          hayExclusivoSeleccionado &&
                          !seleccionadas.includes(valor)
                        );

                      return (
                        <label
                          key={item.CATALOG_KEY}
                          className={`afiliacion-opcion ${
                            seleccionadas.includes(valor) ? "seleccionada" : ""
                          } ${deshabilitado ? "deshabilitada" : ""}`}
                        >
                          <input
                            type="checkbox"
                            checked={seleccionadas.includes(valor)}
                            disabled={deshabilitado}
                            onChange={() => handleAfiliacionChange(valor)}
                          />
                          <span className="afiliacion-check"></span>
                          <span className="afiliacion-texto">
                            {item["DESCRIPCIÓN LARGA"] || item["DESCRIPCIÓN CORTA"]}
                          </span>
                        </label>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          <label>¿Se autodenomina afromexicano?</label>
          <select
            name="seAutodenominaAfromexicano"
            value={datosPaciente.seAutodenominaAfromexicano ?? ""}
            onChange={(e) =>
              setDatosPaciente(prev => ({
                ...prev,
                seAutodenominaAfromexicano: e.target.value === "" ? null : Number(e.target.value)
              }))
            }
          >
            <option value="">Seleccionar</option>
            <option value="0">No</option>
            <option value="1">Sí</option>
            <option value="2">No responde</option>
            <option value="3">No sabe</option>
          </select>

          <label>¿Se considera indígena?</label>
          <select
            name="seConsideraIndigena"
            value={datosPaciente.seConsideraIndigena ?? ""}
            onChange={(e) =>
              setDatosPaciente(prev => ({
                ...prev,
                seConsideraIndigena: e.target.value === "" ? null : Number(e.target.value)
              }))
            }
          >
            <option value="">Seleccionar</option>
            <option value="0">No</option>
            <option value="1">Sí</option>
            <option value="2">No responde</option>
            <option value="3">No sabe</option>
          </select>

          <label>¿Se considera migrante?</label>
          <select
            name="migrante"
            value={datosPaciente.migrante ?? ""}
             onChange={(e) => {
              const nuevoMigrante =
                e.target.value === "" ? null : Number(e.target.value);

              setDatosPaciente(prev => ({
                ...prev,
                migrante: nuevoMigrante,
                paisProcedencia:
                  nuevoMigrante === 2 ? null : prev.paisProcedencia
              }));
            }}
          >
            <option value="">Seleccionar</option>
            <option value="0">No</option>
            <option value="1">Nacional</option>
            <option value="2">Internacional</option>
            <option value="3">Retornado</option>
          </select>

          {datosPaciente.migrante === 2 && (
            <>
              <label>País de procedencia*:</label>
              <select
                name="paisProcedencia"
                value={datosPaciente.paisProcedencia ?? ""}
                required
                onChange={(e) =>
                  setDatosPaciente(prev => ({
                    ...prev,
                    paisProcedencia: e.target.value ? Number(e.target.value) : null
                  }))
                }
              >
                <option value="">Seleccionar</option>
                {listaPaises
                  .filter(p => p.CATALOG_KEY !== 142)
                  .map((pais) => (
                    <option key={pais.CATALOG_KEY} value={pais.CATALOG_KEY}>
                      {pais.DESCRIPCION}
                    </option>
                  ))
                }
              </select>
            </>
          )}

          <label>Género*:</label>
          <select
            name="genero"
            value={datosPaciente.genero ?? ""}
            onChange={(e) =>
              setDatosPaciente(prev => ({
                ...prev,
                genero: e.target.value === "" ? null : Number(e.target.value)
              }))
            }
          >
            <option value="" disabled>Seleccionar</option>
            <option value="0">No especificado</option>
            <option value="1">Masculino</option>
            <option value="2">Femenino</option>
            <option value="3">Transgénero</option>
            <option value="4">Transexual</option>
            <option value="5">Travesti</option>
            <option value="6">Intersexual</option>
            <option value="88">Otro</option>
          </select>
          
          </>
          )}
          {/* Residencia NOM-024 */}
          <h4>Residencia</h4>
          <label>País de residencia*:</label>
          <select
            value={datosPaciente.paisResidencia ?? ""}
            //disabled={bloqueado}
            onChange={(e) => handlePaisResidencia(e.target.value || null)}
          >
            <option value="" disabled>Selecciona un país</option>
            {listaPaises.map((pais) => (
              <option key={pais.CATALOG_KEY} value={pais.CATALOG_KEY}>
                {pais.DESCRIPCION}
              </option>
            ))}
          </select>

          {String(datosPaciente.paisResidencia) === "142" && (
            <>
              <label>Entidad de residencia*:</label>
              <select
                value={datosPaciente.entidadResidencia ?? ""}
                //disabled={bloqueado}
                onChange={(e) => handleEntidadResidencia(e.target.value ? e.target.value : null)}
              >
                <option value="" disabled>Selecciona una entidad</option>
                {listaEntidades.filter((e) => String(e.CATALOG_KEY) !== "88").map((e) => (
                  <option key={e.CATALOG_KEY} value={e.CATALOG_KEY}>
                    {e.ENTIDAD_FEDERATIVA}
                  </option>
                ))}
              </select>
            </>
          )}

          {String(datosPaciente.paisResidencia) === "142" && datosPaciente.entidadResidencia && !esEntidadEspecial(datosPaciente.entidadResidencia) && (
            <>
              <label>Municipio*:</label>
              <select
                value={datosPaciente.municipio ?? ""}
                //disabled={bloqueado}
                onChange={(e) => handleMunicipio(e.target.value || null)}
              >
                <option value="" disabled>Selecciona un municipio</option>
                <option value="998">SE IGNORA - 998</option>
                <option value="999">NO ESPECIFICADO - 999</option>
                {listaMunicipios.map((m) => (
                  <option key={m.CATALOG_KEY} value={m.CATALOG_KEY}>
                    {m.MUNICIPIO} - {m.CATALOG_KEY}
                  </option>
                ))}
              </select>
            </>
          )}

          {String(datosPaciente.paisResidencia) === "142" && datosPaciente.municipio && !esMunicipioEspecial(datosPaciente.municipio) && (
            <>
              <label>Localidad*:</label>
              <select
                value={datosPaciente.localidad ?? ""}
                //disabled={bloqueado}
                onChange={(e) => setDatosPaciente(prev => ({ ...prev, localidad: e.target.value || null }))}
              >
                <option value="" disabled>Selecciona una localidad</option>
               <option value="9998">SE IGNORA - 9998</option>
               <option value="9999">NO ESPECIFICADO - 9999</option>
                {listaLocalidades.map((l) => (
                  <option key={l.CATALOG_KEY} value={l.CATALOG_KEY}>
                    {l.LOCALIDAD} - {l.CATALOG_KEY}
                  </option>
                ))}
              </select>
            </>
          )}

          {/* Dirección */}
           <h4>Dirección</h4>
          <label>Dirección - Calle y Número:</label>
          <input
            type="text"
            name="direccion.calle"
            value={datosPaciente.direccion?.calle || ""}
            onChange={handleChange}
          />

          {/* Colonia */}
          <label>Colonia:</label>
          <input
            type="text"
            name="direccion.colonia"
            value={datosPaciente.direccion?.colonia || ""}
            onChange={handleChange}
          />

          {/* Ciudad */}
          <label>Ciudad:</label>
          <input
            type="text"
            name="direccion.ciudad"
            value={datosPaciente.direccion?.ciudad || ""}
            onChange={handleChange}
          />

          {/* Estado */}
          <label>Estado:</label>
          <input
            type="text"
            name="direccion.estado"
            value={datosPaciente.direccion?.estado || ""}
            onChange={handleChange}
          />

            {/* Código Postal */}
          <label>Código Postal:</label>
          <input
            type="text"
            name="direccion.codigo_postal"
            value={datosPaciente.direccion?.codigo_postal || ""}
            onChange={handleChange}
          />
           

          {/* Motivo de Consulta */}
          <h4>Motivo de Consulta:</h4>
         
          <input
            type="text"
            name="motivo_consulta"
            value={datosPaciente.motivo_consulta || ""}
            onChange={handleChange}
          />
          {renderNota("motivo_consulta")}

          <div className="modal-buttons">
            <button type="submit">Guardar Cambios</button>
            <button type="button" onClick={onClose}>Cancelar</button>
          </div>
        </form>
        <ConfirmarPalabraInconvenienteCURP
          visible={confirmarPalabraInconveniente}
          onConfirm={() => {
            curpPalabraInconvenienteConfirmadaRef.current = true;
            setCurpPalabraInconvenienteConfirmada(true);
            setConfirmarPalabraInconveniente(false);

           setTimeout(() => {
            formEditarPacienteRef.current?.requestSubmit();
          }, 0);
          }}
          onCancel={() => {
            curpPalabraInconvenienteConfirmadaRef.current = false;
            setConfirmarPalabraInconveniente(false);
            setCurpPalabraInconvenienteConfirmada(false);
          }}
        />
      </div>
    </div>
  );
};

export default ModalEditarPaciente;